import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { AcctShell } from "../features/acct/AcctShell";
import { NeuTabs } from "../components/neu/NeuTabs";
import { DateInput } from "../components/neu/DateInput";
import { AcctReportSection } from "../features/acct/AcctReportSection";
import { ACCT_REPORT_KEYS, ACCT_REPORT_TABS } from "../features/acct/acctReportTabs";
import { useAcctReports } from "../features/acct/useAcctReports";

export default function AcctReportsPage() {
  const { t } = useTranslation();
  const [dates, setDates] = useState({ date_from: "", date_to: "" });
  const data = useAcctReports(dates);
  const [params, setParams] = useSearchParams();
  const tab = ACCT_REPORT_KEYS.includes(params.get("tab")) ? params.get("tab") : "income";

  return (
    <AcctShell titleKey="reports">
      <div className="flex flex-wrap gap-3">
        {["date_from", "date_to"].map((key) => (
          <DateInput
            key={key}
            className="w-40"
            label={t(`acct.${key}`)}
            testId={`rep-${key}`}
            value={dates[key]}
            onChange={(v) => setDates((prev) => ({ ...prev, [key]: v }))}
          />
        ))}
      </div>

      <NeuTabs
        testid="acct-report-tabs"
        value={tab}
        onChange={(key) => setParams(key === "income" ? {} : { tab: key })}
        tabs={ACCT_REPORT_TABS.map(({ key, icon }) => ({ key, icon, label: t(`acct.reportTabs.${key}`) }))}
      />

      <div data-testid={`acct-report-panel-${tab}`}>
        <AcctReportSection tab={tab} data={data} range={dates} />
      </div>
    </AcctShell>
  );
}
